module.exports = __webpack_public_path__ + "static/media/tti_targeting@2x.6ca15468.png";